import axios from "axios";
import _ from "lodash";
import { useEffect, useState } from 'react';
import { api } from '../utils';

export default function useGetPOETAByItemNumber(itemNumber) {
  const item = itemNumber;
  const [isLoading, setIsLoading] = useState(true);
  const [itemNumberState, setItemNumberState] = useState("");
  const [PoData, setPoData] = useState({ InTransitPoz: [], OnOrderPoz: [] });

  useEffect(() => {
    if(!item || !item.length) {
        setIsLoading(false);
        return;
    }
    setItemNumberState(item);
    if(itemNumberState === item) return;
    setIsLoading(true);
    const cancelToken = axios.CancelToken;
    const source = cancelToken.source();

    api.fetchS(`Purchasing/GetPOETAByItemNumber/${itemNumber}`, {}, source.token)
      .then(response => {
        if(response.data.success){
            return response.data.poData
        } else {
           throw new Error("Whoops fetching PO Data failed");
        }
      }).then(data => {
        //TRXLOCTN value might change when implementing in the backend
        const [inTransit, onOrder] = _.partition(data, { 'location':'INTRANSIT' });
          setPoData({
            InTransitPoz: inTransit,
            OnOrderPoz: onOrder
          });
        }
      )
      .catch(api.catchHandler)
      .finally(() => setIsLoading(false));

      return () => { 
        source.cancel("axios request cancelled"); 
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemNumber]);

  return [PoData.InTransitPoz, PoData.OnOrderPoz, isLoading];
}

